export default [
  {
    path: '/zyhzscb',
    component: () => import('./views/select')
  }
]



// WEBPACK FOOTER //
// ./src/page/zyhzscb/router.js